import { useCallback, useContext } from 'react'
import { KeycloakAdminService, KeycloakService } from '@nv/auth'
import { LoginFlowContext } from '@nv/contexts'
import { AdminVoterAuthService, VoterAuthService } from '@nv/services'
import { beforeUnload } from '@nv/utils'
import { useNavigate } from 'react-router-dom'

export const useHandleLogout = () => {
  const navigate = useNavigate()
  const LOGIN_CONTEXT = useContext(LoginFlowContext)

  return useCallback(async () => {
    window.removeEventListener('beforeunload', beforeUnload)
    try {
      if (KeycloakService.isLoggedIn()) {
        LOGIN_CONTEXT.setLoginFlow('Login')
        await VoterAuthService.logOut(navigate)
      }
      if (KeycloakAdminService.isLoggedIn()) {
        LOGIN_CONTEXT.setLoginFlow('Admin Login')
        await AdminVoterAuthService.logOut(navigate)
      }
    } catch (error) {
      // handle or log error if needed
    }
  }, [navigate, LOGIN_CONTEXT])
}
